import {createAsyncThunk} from "@reduxjs/toolkit";
import {Template} from "../../../@types/template";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const createFileTemplate = createAsyncThunk(
  "templateCreate/createFileTemplate",
  async ({name, archive, sourceOrganization}: {
    name: string,
    archive: any,
    sourceOrganization: string
  }, {rejectWithValue}) => {
    try {
      const {data} = await axiosInstance.post(`${api.baseURL}form`, {
        name,
        archive,
        sourceOrganization,
      });

      return data as Template;

    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
